// import axios from 'axios';

const state = {
  lang: { title: 'English', code: 'en' },
  locale: {
      en: {
        header_menu: {
          about_us: 'About us',
          services: 'Services',
          contact: 'Contact us',
          platform: 'Platform'
        },
        hero_section: {
          title: 'Your broker in energetics.',
          body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          cta: 'Learn more',
        },
        about_section: {
          title: 'About us',
          body_intro: 'The team behind "Beta Logistics OOD" consists of long-term experts in the field of research and market services. The mission of Betalogistics is to realize the connection between the individual sectors of the market by offering an innovative software tool.',
          body: 'Betaenergy is a software product of the company "Beta Logistics OOD" - an internet platform for offering goods and services in the field of energetics. The platform fulfills an intermediary function, providing opportunities for the buyer to discover products from the field of energetics. It guarantees correct execution of the order and eliminates the paperwork process. To get the services of the platform, every buyer provides their details and goes through an approval process before getting access.',
          listed_1: 'Opportunity for Sellers to have their own Internet platform for sales in the field of energy, with their interests and technology being protected. Their anonymity is guaranteed until an agreement is reached with the other party to the contract.',
          listed_2: 'Opportunity for Buyers to purchase products in the field of energy, guaranteeing the correct execution of the order and undertaking the process of document processing. The buyer provides their details and goes through an approval process to access the services offered.',
          conclusion: 'Betaenergy makes possible the connection between the two parties with the highest level of security and confidentiality of information.',
        },
        services_section: {
          
        },
        contact_sections: {

        },
        footer_menu: {
          disclamer: 'Disclamer',
          cookies: 'Cookie Policy',
          tos: 'Terms of Service',
          gdrp: 'Privacy Policy',
        },
        cookies: {
          cookie_text: 'We use cookies on our website to provide you with the most relevant experience by remembering your preferences and repeat visits. By clicking "Accept" you consent to the use of ALL cookies.',
          cookie_btn: 'Accept',
        },
        login: {
          title: 'User Platform',
          email_label: 'Email',
          password_label: 'Password',
          login_btn: 'Login',
          back_btn: 'Back to home page',
        },
        platform: {
          navigation_menu: {
            orders: [
              // new_order: [
                {
                title: 'Create New Order', 
                href: '/home/order', 
                icon: 'mdi-file-document-plus'
                },
              // ],
              // order_history: [
                {
                title: 'Order History', 
                href: '/home/history', 
                icon: 'mdi-clipboard-text-clock'
                }
              // ],
            ],
            profile: [
              {
              title: 'Profile', 
              href: '/home/', 
              icon: 'mdi-account'
              }
            ],
            exit: 'Exit',
          },
          profile_menu: {
            menu_title: 'User Profile',
            card_title: 'Settings',
            first_name: 'First Name:',
            last_name: 'Last Name:',
            email: 'Email:',
            new_password: {
              password_title: 'New password:',
              password_placeholder: 'New password',
            },
            confirm_password: {
              password_title: 'Confirm password:',
              password_placeholder: 'Confirm password',
            },
            old_password: {
              password_title: 'Current password:',
              password_placeholder: 'Current password',
            },
            update_btn: 'Update',
          },
          order_menu: {
            order_selection_menu: {
              title: 'Creating New Order - Select Product',
              continue_btn: 'Continue',
            },
          }
        },
        error: {
          message_404: 'Page not found!',
        },
      },
      bg: {
          header_menu: {
            about_us: 'За нас',
            services: 'Услуги',
            contact: 'Контакт',
            platform: 'Платформа'
          },
          hero_section: {
            title: 'Вашият посредник в сферата на енергетиката',
            body: 'Lorem ipsum dolor sit amet.',
            cta: 'Научи повече',
          },
          about_section: {
            title: 'За Нас',
            body_intro: 'Екипът зад "Бета Логистика ООД" се състои от дългогодишни експерти в сферата на научно-изследователската дейност и пазарните услуги. Мисията на Беталогистика е да реализира връзката между отделните сектори на пазара, като предложи иновативен софтуерен инструмент.',
            body: 'Бетаенерджи (англ. Betaenergy) представлява софтуерен продукт на фирма "Бета Логистика ООД" за интернет платформа за предлагане на стоки и услуги в сферата на енергетиката. Платформата изпълнява посредническа функция, осигуряваща възможности на купувача да открият продукти от сферата на енергетиката. Гарантира се коректно изпълнение на поръчката и премахне документалния процес. За да получи услугите на платформата, всеки купувач предоставя своите данни и минава процес на одобрение преди да получи достъп.',
            listed_1: 'Възможност на Продавачите да имат собствена интернет платформа за продажби в сферата на енергетиката, като техните интереси и технология биват защитени. Анонимността им е гарантирана до сключването на споразумение с другата страна по договора.',
            listed_2: 'Възможност на Купувачите да закупят продукти в сферата на енергетиката, като се гарантира коректно изпълнение на поръчката и се поема процесът по обработка на документите. Купувачът предоставя своите данни и преминава през процес на одобрение, за да получи достъп до предлаганите услуги.',
            conclusion: 'Бетаенерджи прави възможна връзката между двете страни с най-високо ниво на сигурност и конфиденциалност на информацията.',
          },
          services_section: {
          
          },
          contact_sections: {

          },
          footer_menu: {
              disclamer: 'Опровержение',
              cookies: 'Бисквитки',
              tos: 'Общи условия',
              gdrp: 'Политика за личните данни',
          },
          cookies: {
            cookie_text: 'Ние използваме бисквитки на нашия уебсайт, за да ви предоставим най-подходящото изживяване, като запомним вашите предпочитания и повтаряме посещенията. С натискането на „Приемам“ вие се съгласявате с използването на ВСИЧКИ бисквитки.',
            cookie_btn: 'Приемам',
          },
          login: {
            title: 'Потребителски панел',
            email_label: 'Ел. поща',
            password_label: 'Парола',
            login_btn: 'Влез',
            back_btn: 'Обратно към начална страница',
          },
          platform: {
            navigation_menu: {
              new_order: [
                {
                title: 'Създай поръчка', 
                href: '/home/order', 
                icon: 'mdi-file-document-plus'
                }
              ],
              order_history: [
                {
                title: 'История на поръчки', 
                href: '/home/history', 
                icon: 'mdi-clipboard-text-clock'
                }
              ],
              profile: [
                {
                title: 'Профил', 
                href: '/home/', 
                icon: 'mdi-account'
                }
              ],
              exit: 'Излез',
            },
            profile_menu: {
              menu_title: 'Потребителски профил',
              card_title: 'Настройки',
              first_name: 'Име:',
              last_name: 'Фамилия:',
              email: 'Поща:',
              new_password: {
                password_title: 'Нова парола:',
                password_placeholder: 'Нова парола',
              },
              confirm_password: {
                password_title: 'Потвърди парола:',
                password_placeholder: 'Потвърди парола',
              },
              old_password: {
                password_title: 'Настояща парола:',
                password_placeholder: 'Настояща парола',
              },
              update_btn: 'Обнови',
            },
            order_menu: {
              order_selection_menu: {
                title: 'Създаване на нова поръчка - Избор на продукт',
                continue_btn: 'Напред',
              },
            }
          },
          error: {
            message_404: 'Страницата не е намерена!',
          },
      },
      tr: {
          header_menu: {
              about_us: 'Hakkımızda',
              services: 'Hizmetler',
              contact: 'Bize Ulaşın',
              platform: 'Platformu'
          },
          hero_section: {
              title: 'Enerjinde kırılmışsın',
              body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              cta: 'Daha fazla bilgi edin',
          },
          about_section: {
            title: 'Hakkımızda',
            body_intro: "'Beta Logistics OOD' arkasındaki ekip, araştırma ve pazar hizmetleri alanında uzun yıllara dayanan uzmanlardan oluşmaktadır. Betalojistik'in misyonu, yenilikçi bir yazılım aracı sunarak pazarın bireysel sektörleri arasındaki bağlantıyı gerçekleştirmektir.",
            body: 'Betaenergy, enerji alanında mal ve hizmet sunan bir internet platformu olan "Beta Logistics OOD" şirketinin bir yazılım ürünüdür. Platform, alıcının enerji alanından ürünleri keşfetmesi için fırsatlar sunan aracı bir işlevi yerine getirir. Siparişin doğru bir şekilde yerine getirilmesini garanti eder ve evrak sürecini ortadan kaldırır. Platformun hizmetlerinden yararlanmak için her alıcı, bilgilerini sağlar ve erişim elde etmeden önce bir onay sürecinden geçer.',
            listed_1: 'Satıcıların ilgi alanları ve teknolojileri korunarak enerji alanında satış yapmak için kendi İnternet platformlarına sahip olma fırsatı. Anonimlikleri, sözleşmenin diğer tarafıyla bir anlaşmaya varılana kadar garanti edilir.',
            listed_2: 'Alıcılar için, siparişin doğru bir şekilde yerine getirilmesini garanti eden ve belge işleme sürecini üstlenen, enerji alanında ürün satın alma fırsatı. Alıcı, bilgilerini sağlar ve sunulan hizmetlere erişmek için bir onay sürecinden geçer.',
            conclusion: 'Betaenerji, iki taraf arasındaki bağlantıyı en üst düzeyde güvenlik ve bilgi gizliliği ile mümkün kılar.',
          },
          services_section: {
          
          },
          contact_sections: {

          },
          footer_menu: {
            cookies: 'Çerez politikası',
            tos: 'Kullanım Şartları',
            gdrp: 'Gizlilik Politikası',
          },
          cookies: {
            cookie_text: 'Tercihlerinizi ve tekrar ziyaretlerinizi hatırlayarak size en alakalı deneyimi sağlamak için web sitemizde çerezler kullanıyoruz. "Kabul Et"i tıklayarak TÜM tanımlama bilgilerinin kullanımına izin vermiş olursunuz.',
            cookie_btn: 'Kabul et',
          },
          login: {
            title: 'Kullanıcı Platformu',
            email_label: 'E-posta',
            password_label: 'Şifre',
            login_btn: 'Giriş',
            back_btn: 'Ana sayfaya dön',
          },
          platform: {
            navigation_menu: {
              new_order: [
                {
                  title: 'Yeni Sipariş', 
                  href: '/home/order', 
                  icon: 'mdi-package-up'
                  }
              ],
              profile: [
                {
                title: 'Profil', 
                href: '/home/', 
                icon: 'mdi-account'
                }
              ],
              exit: 'Çıkış',
            },
            profile_menu: {
              menu_title: 'Kullanıcı Profili',
              card_title: 'Ayarlar',
              first_name: 'Ad:',
              last_name: 'Soyadı:',
              email: 'Posta:',
              new_password: {
                password_title: 'Yeni Şifre:',
                password_placeholder: 'Yeni Şifre',
              },
              confirm_password: {
                password_title: 'Şifreyi onayla:',
                password_placeholder: 'Şifreyi onayla',
              },
              old_password: {
                password_title: 'Geçerli şifre:',
                password_placeholder: 'Geçerli şifre',
              },
              update_btn: 'Güncelle',
            },
            order_menu: {
              order_selection_menu: {
                title: 'Yeni Sipariş Oluşturma - Ürün Seçin',
                continue_btn: 'Devam et',
              },
            }
          },
          error: {
            message_404: 'Sayfa bulunamadı!',
          },
      },
  }
}

const getters = {
  userLang: state => state.lang,
}

const actions = {
  async changeLanguage({commit}, lang) {
    commit('setUserLang', lang)
  },
}

const mutations = {
  setUserLang(state, lang) {
    state.lang = lang
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}